import { ChatMessage } from '../ui/HUD/ChatTypes';
import { gameLogger } from '../../utils/GameLogger';

/**
 * DebugLogService
 * 
 * Centralized service for logging high-priority debug information 
 * to the dedicated Debug Tab in the Chat UI.
 */
export class DebugLogService {
  private static instance: DebugLogService;
  private listeners: ((message: ChatMessage) => void)[] = [];

  private constructor() {}

  public static getInstance(): DebugLogService {
    if (!DebugLogService.instance) {
      DebugLogService.instance = new DebugLogService();
    }
    return DebugLogService.instance;
  }

  /**
     * Log a message to the Debug Tab
     * @param text The message to log
     * @param sender Optional sender name (defaults to 'Debug')
     */
  public log(text: string, sender: string = 'Debug'): void {
    const message: ChatMessage = {
      id: `debug_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      sender,
      text,
      timestamp: Date.now(),
      type: 'debug'
    };

    // Also log to browser console for dev convenience
    gameLogger.debug('debug', `[DEBUG_TAB] ${text}`);

    // Notify listeners (Game.tsx)
    this.listeners.forEach(listener => listener(message));
  }

  /**
     * Subscribe to debug logs
     */
  public subscribe(listener: (message: ChatMessage) => void): () => void {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }
}
